<template>
    <div class="autocomplete">
        <i class="fa fa-search"></i>
        <i class="fa fa-times" v-show="!readonly"  v-if="param" @click="close"></i>
        <input
            :class="'autocomplete-input ' + classes"
            ref="input"
            :disabled="disabled"
            v-bind="{'readonly':readonly}"
            @keyup="search"
            v-model="param"
            :placeholder="placeholder"
        />
        <ul
            class="autocomplete-options"
            v-if="sources.length > 0"
            v-show="showing"
        >
            <li
                class="autocomplete-options-item"
                v-for="(item, index) in sources"
                :key="index"
                @click.prevent="selected(item)"
            >
                <span v-if="!simple">{{ serializer(item) }}</span>
                <span v-else>{{ item }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        classes: null,
        placeholder: null,
        serializer: {
            type: Function,
            default: (d) => d,
            validator: (d) => d instanceof Function,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        serializerId: {
            type: Function,
            default: (d) => d,
            validator: (d) => d instanceof Function,
        },
        per_page: {
            type: Number,
            default: 10,
        },
        sources: {
            type: Array,
            default: () => [],
        },
        max: {
            type: Number,
            default: 3,
        },
        simple: {
            type: Boolean,
            default: true,
        },
        setItem: {
            type: Object,
            default: () => {},
        },
    },
    data: function () {
        return {
            param: "",
            showing: true,
        };
    },
    watch: {
        setItem: function (val, old) {
            if (val) {
                this.param = this.serializer(val);
            }
        },
    },
    methods: {
        search() {
            this.showing = true;
            if (this.param.length > this.max) {
                this.$emit("search", this.param);
            }
        },
        selected(item) {
            this.showing = false;
            this.param = this.serializer(item);
            this.$emit("selected-item", item);
        },
        close() {
            this.param = null;
            this.$emit("selected-item", null);
        },
    },
};
</script>

<style>
.autocomplete {
    position: relative;
}

.autocomplete > i {
    position: absolute;
}

.autocomplete > .fa-search {
    left: 15px;
    padding-top: 15px;
}

.autocomplete > .fa-times {
    right: 15px;
    padding-top: 15px;
}

.autocomplete-options {
    position: absolute;
    background: #fff;
    list-style: none;
    border-left: 1px solid #c1c1c1;
    border-right: 1px solid #c1c1c1;
    border-bottom: 1px solid #c1c1c1;
    width: 100%;
    top: 41px;
    z-index: 1000;
    border-radius: 0px 0px 5px 5px;
}

.autocomplete-options-item {
    width: 100%;
    /* height: 35px; */
    padding: 8px 10px !important;
    border-bottom: 1px solid #c1c1c1;
}

.autocomplete-input {
    padding-left: 40px;
    padding-right: 40px;
}
</style>
